<!-- src/app/pages/cost-metrics/simulation-panel/simulation-controls/simulation-controls.html -->
<div class="tabHeading">
    <h3>Intervention Controls</h3>
    <div class="panelCheckbox">
        @if (currentCountry(); as cc) {
        <div class="parentCheckbox">
            <p-accordion [multiple]="false" [(value)]="openCategoryIndexes">
                @for (cat of cc.categories; track cat; let catIdx = $index) {
                <p-accordion-panel [value]="catIdx">
                    <p-accordion-header>
                        <span class="f12">
                            {{ cat.category }}
                            <span class="activeBg inline-flex items-center rounded-full bg-blue-50 px-2 py-1 text-xs font-medium ml-3"> {{ cat.interventions.length }} </span>
                        </span>
                    </p-accordion-header>
                    <p-accordion-content>
                        @for (intv of cat.interventions; track intv; let intvIdx = $index) {
                        <div>
                            <div class="checboxWrap" (click)="$event.stopPropagation()">
                                <p-checkbox [name]="cat.category" [value]="intv.name" [(ngModel)]="selectedOptions[cat.category]" [inputId]="cat.category + '-' + intv.id"> </p-checkbox>
                                <label [for]="cat.category + '-' + intv.id" (click)="togglePanel(cat.category, intv.id); $event.preventDefault(); $event.stopPropagation()" style="cursor: pointer">
                                    {{ displayName(intv) }} <i class="pi pi-search-plus"></i>
                                </label>
                            </div>
                            <div class="interventionContent" [style.display]="isOpen(cat.category, intv.id) ? 'block' : 'none'">
                                <h3 class="p-4 flex justify-between items-center">
                                    {{ displayName(intv) }}
                                    <button type="button" (click)="togglePanel(cat.category, intv.id); $event.preventDefault(); $event.stopPropagation()" class="backBtn">Go back <i class="pi pi-arrow-right"></i></button>
                                </h3>
                                <div class="content-grid">
                                    @for (p of intv.parameters; track p; let pIdx = $index) {
                                    <div class="param-tile">
                                        <div class="param-tile-left">
                                            <div class="param-tile-left-content" style="font-size: 0.75rem; color: #6b7280">{{ p.interface_name }}</div>
                                            <p-slider [(ngModel)]="parameterValues[intv.id][pIdx]" [min]="p.range.min" [max]="p.range.max" [step]="p.step || ((p.range.max - p.range.min) < 10 ? 0.1 : 1)" [style]="{width:'100%'}"> </p-slider>
                                        </div>
                                        <div class="param-tile-right">
                                            <h5>{{ parameterValues[intv.id][pIdx] }}</h5>
                                        </div>
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                        }
                    </p-accordion-content>
                </p-accordion-panel>
                }
            </p-accordion>
        </div>
        } @else {
        <p>Loading or no data available.</p>
        }
    </div>
</div>
